<template>
  <section class="container section pt-5">
    <div class="title is 3">
      {{ $t("payment register") }}
    </div>
    <div class="form">
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("type") }}</label>
            <div class="control">
              <div class="select">
                <select
                  v-model="meta.type"
                  v-if="order.source && order.source.available_payment_methods"
                >
                  <option
                    :value="pm"
                    v-for="(pm, ipm) in order.source.available_payment_methods"
                  >
                    {{ $t(pm) }}
                  </option>
                  <!-- <option value="deposit">{{ $t("deposit") }}</option>
                  <option value="transference">{{ $t("transference") }}</option>
                  <option value="cash">{{ $t("cash") }}</option> -->
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("date") }}</label>
            <generic-calendar
              type="date"
              display_mode="dialog"
              ref="date_calendar"
              @selected="date_changed"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("amount") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input is-medium"
                type="text"
                v-model="meta.amount"
              />
              <span class="icon is-left">
                <i class="fa fa-credit-card"></i>
              </span>
            </div>
          </div>
        </div>
        <div
          class="column"
          v-if="['transference', 'deposit'].includes(meta.type)"
        >
          <div class="field">
            <label class="label">{{ $t("document number") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.document_number" />
            </div>
          </div>
        </div>
        <div class="column" v-if="['cash'].includes(meta.type)">
          <div class="field">
            <label class="label">{{ $t("receipt number") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.receipt_number" />
            </div>
          </div>
        </div>
        <div class="column" v-if="['transference'].includes(meta.type)">
          <div class="field">
            <label class="label">{{ $t("bank") }}</label>
            <div class="control">
              <div class="select">
                <select v-model="meta.bank">
                  <option>BI</option>
                  <option>Banrural</option>
                  <option>G&T Continental</option>
                  <option>BAM</option>
                  <option>BAC</option>
                  <option>Promerica</option>
                  <option>Bantrab</option>
                  <option>Banco Internacional</option>
                  <option>CHN</option>
                  <option>Otros</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <article class="message is-info">
        <div class="message-body">
          <div class="content">
            <ul>
              <li>
                {{ $t("to register your payment, verify you fill all fields") }}
              </li>
              <li v-if="order.source">
                {{ $t("if deposit or transference, consider next info") }}.
                <ul>
                  <li>{{ $t("bank") }}: {{ order.source.bank }}</li>
                  <li>
                    {{ $t("account name") }}:
                    {{ order.source.bank_account_name }}
                  </li>
                  <li>
                    {{ $t("account type") }}:
                    {{ $t(order.source.bank_account_type) }}
                  </li>
                  <li>
                    {{ $t("account number") }}:
                    {{ order.source.bank_account_number }}
                  </li>
                </ul>
              </li>
              <li>
                {{ $t("deposits and transferences must be verified by us") }}
              </li>
            </ul>
          </div>
        </div>
      </article>
      <article class="message is-success" v-show="success && false">
        <div class="message-header">
          <p>{{ $t("payment registered") }}</p>
        </div>
        <div class="message-body">
          {{ $t("your payment has been registered") }}
        </div>
      </article>
      <div class="field">
        <div class="control">
          <button
            class="button is-rounded is-primary"
            @click="save"
            :disabled="is_invalid"
          >
            <span class="icon">
              <i class="fa fa-save"></i>
            </span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- <pre>{{ meta }}{{ order }}</pre> -->
  </section>
</template>

<script>
import {
  get,
  post,
  put,
  error_message,
  format_currency,
  success_message,
} from "@/utils";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import moment from "moment";

export default {
  name: "TailoringOrderPayment",
  components: { GenericCalendar },
  computed: {
    is_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.type ||
        !v.meta.date ||
        !v.meta.amount ||
        Number.isNaN(Number(v.meta.amount)) ||
        (["transference"].includes(v.meta.type) &&
          (!v.meta.document_number || !v.meta.bank)) ||
        (v.meta.type == "cash" && !v.meta.receipt_number) ||
        (["deposit"].includes(v.meta.type) && !v.meta.document_number)
      );
    },
  },
  data() {
    return {
      order: {},
      success: false,
      meta: {
        document_number: "",
      },
    };
  },
  methods: {
    date_changed(date) {
      let v = this;
      v.meta.date = moment(date).format("DD/MM/YYYY");
    },
    save() {
      let v = this;
      v.$root.loader(true);
      put("/tailoring_order/link/payment", {
        uuid: v.$route.params.id,
        ...v.meta,
      })
        .then((response) => {
          v.success = true;
          success_message(v.$t("payment registered"));
          v.meta = {
            document_number: "",
            date: "",
            amount: "",
            bank: "",
          };
          v.$refs.date_calendar.clear();
          setTimeout(() => {
            if (v.$route.params.url)
              v.$router.push({
                path: `/tailoring_order/order/${v.$route.params.url}`,
              });
          }, 2000);
        })
        .catch((error) => {
          error_message(error);
          console.error(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    go_home() {
      let v = this;
      v.$router.go(-1);
    },
  },
  mounted() {
    let v = this;
    let uuid = v.$route.params.id;
    get("/tailoring_order/link/order", { uuid })
      .then((response) => {
        v.order = response;
        if (response && response.total) v.meta.amount = response.total;
      })
      .catch((error) => {
        error_message(error);
        console.error(error);
      });
  },
  created() {},
};
</script>

<style scoped></style>
